
let TestModel = require('@/mixins/Forms/2022/TestModel')

module.exports = {

    mixins: [TestModel],

    data() {
        return {
            max_zones: 4,
            zone_options: {
                'sky': 'Skylit',
                'ps': 'Primary Sidelit',
                'ss': 'Secondary Sidelit',
                'cps': 'Combined Primary and Secondary',
            },
            construction_inspection: {
                name: `Construction Inspection (NA7.6.1.1)`,
                questions: {
                    question_1:{
                        id:`1`,
                        question:`The automatic daylighting controls are shown on the plan documents and are installed.`,
                        code_reference:`NA7.6.1.1`,
                        answer:false,
                    },
                    question_2: {
                        id: `2`,
                        question: `The general lighting in skylit daylit zones, primary sidelit daylit zones and secondary sidelit daylit zone is controlled by automatic daylight controls. In parking garages, the general lighting in the combined primary and secondary sidelit daylit zones is controlled by automatic daylighting controls ()`,
                        code_reference:`NA7.6.1.1(b), Section 130.1(d) ,Section 160.5(b)4D`,
                        answer: false,
                    },
                    question_2_1: {
                        id: `3`,
                        question: `The daylit zones are shown on page(s) of plans; <b>OR</b> The daylit zones are drawn in on page(s) of as-built plans (attached).`,
                        code_reference:`NA7.6.1.1(a) ,Section 130.1(d)1, Section 160.5(b)4Di`,
                        answer: false
                    },
                    question_2_2: {
                        id: `3.1`,
                        question: `The daylit zones are drawn in on page(s) of as-built plans (attached). (Section 130.1(d)1)`,
                        code_reference:``,
                        answer: false
                    },
                    question_2_3: {
                        id: `3.1`,
                        question: `Indicate the page number:`,
                        code_reference:null,
                        answer: '',
                    },
                    question_3: {
                        id: `4`,
                        question: `The automatic daylighting controls provide separate control for luminaires in each type of daylit zone. General lighting in overlapping skylit daylit zone and a sidelit daylit zone are controlled as part of the skylit zone. General lighting in both a primary sidelit daylit zone and secondary sidelit daylit zone are controlled as part of the primary sidelit dayliy zone.`,
                        code_reference:`NA7.6.1.1(c), Section 130.1(d)2, Section 160.5(b)4Dii`,
                        answer: false
                    },
                    question_4: {
                        id: `5`,
                        question: `All photosensors are not readily accessible to unauthorized personnel.`,
                        code_reference:`NA7.6.1.1(d), Section 130.1(d)4, Section 160.5(b)4Div`,
                        answer: false
                    },
                },
                result: false,
            }
        }
    },

    mounted() {
        this.form = new Form({
            nlcaa_procedure: {
                questions: {
                    usign_artificial_light_test: {
                        id: `a`,
                        type: 'Boolean',
                        question: `Will an artificial light source be used to complete this test?`,
                        answer: false,
                    },
                    method_used_for_the_test: {
                        id: `b`,
                        type: 'Option',
                        question: `Method used for the test?`,
                        options: [
                            'Flashlight',
                            'Other Artificial Light',
                        ],
                        answer: '',
                        display: false,
                    },
                    artificial_light_test_reason: {
                        id: 'c',
                        type: 'Option',
                        question: `Reason`,
                        options: [
                            'North Facing Fenetration',
                            'Lack of Natural Light',
                            'Obstruction',
                            'Other',
                        ],
                        answer: '',
                        display: false,
                    },
                    other_reason: {
                        placeholder: 'Reason of the artificial light method...',
                        type: 'Textarea',
                        answer: '',
                        display: false,
                    }
                },
            },
            construction_inspection: this.construction_inspection,
            functional_test: this.functional_test,
            comments: '',
            testResult: false,
        }, false)
        this.loadFormData();
    },

    methods: {

        save() {
            this.form.patch(this.url)
                .then(response => this.redirectTo(this.returnUrl))
                .catch(error => Alert.error(error.first()))
        },

        loadFormData() {

            if (this.data == null) {
                this.addZone();
                return;
            }

            if (this.data.nlcaa_procedure) {
                _.each(this.data.nlcaa_procedure.questions, (question, i) => {
                    this.form.nlcaa_procedure.questions[i].answer = question.answer;
                })
            }

            _.each(this.data.construction_inspection.questions, (question, i) => {
                this.form.construction_inspection.questions[i].answer = question.answer;
            })

            _.each(this.data.functional_test.zones, zone => {
                this.updateQuestionZones(zone);
            })

            _.each(this.data.functional_test.steps, (step, s) => {
                _.each(step.questions, (question, i) => {
                    _.each(this.data.functional_test.zones, (zone, z) => {
                        if (!this.isText(this.form.functional_test.steps[s].questions[i])) {
                            this.form.functional_test.steps[s].questions[i].zones[z].answer = question.zones[z].answer
                        }
                    })
                })
            })

            this.form.comments = this.data.comments;
        },

        initTest() {

            if (!this.testIsReady) {
                return;
            }

            this.nlcaaProcedure();
            this.constructionInspectionEvaluation();
            this.functionalTestEvaluation();

            this.form.testResult = (this.form.construction_inspection.result && this.form.functional_test.result);
        },

        nlcaaProcedure() {

            var display = this.form.nlcaa_procedure.questions.usign_artificial_light_test.answer;
            var isOther = this.form.nlcaa_procedure.questions.artificial_light_test_reason.answer == 'Other';

            this.form.nlcaa_procedure.questions.artificial_light_test_reason.display = display;
            this.form.nlcaa_procedure.questions.method_used_for_the_test.display = display;
            this.form.nlcaa_procedure.questions.other_reason.display = (display && isOther);

            if (!this.form.nlcaa_procedure.questions.usign_artificial_light_test.answer) {
                this.form.nlcaa_procedure.questions.artificial_light_test_reason.answer = '';
                this.form.nlcaa_procedure.questions.method_used_for_the_test.answer = '';
                this.form.nlcaa_procedure.questions.other_reason.answer = '';
            }
        },

        constructionInspectionEvaluation() {
            this.form.construction_inspection.result = true;

            if (this.form.construction_inspection.questions.question_1.answer == false) {
                this.form.construction_inspection.result = false;
            }
            if (this.form.construction_inspection.questions.question_2.answer == false) {
                this.form.construction_inspection.result = false;
            }
            if (this.form.construction_inspection.questions.question_2_1.answer == false && this.form.construction_inspection.questions.question_2_2.answer == false) {
                this.form.construction_inspection.questions.question_2_3.answer = "";
                this.form.construction_inspection.result = false;
            }
            if (this.form.construction_inspection.questions.question_2_3.answer.trim() == "") {
                this.form.construction_inspection.result = false;
            }
            if (this.form.construction_inspection.questions.question_3.answer == false) {
                this.form.construction_inspection.result = false;
            }
            if (this.form.construction_inspection.questions.question_4.answer == false) {
                this.form.construction_inspection.result = false;
            }
        },

        functionalTestEvaluation() {
            // Needs to be called from the test component.
        },

        removeZone() {
            var zone = this.form.functional_test.zones[this.form.functional_test.zones.length - 1];
            Alert.confirmation(`All data from ${zone} zone will be removed.<br>Do you want to continue?`).then(response => {
                var index = this.form.functional_test.zones.indexOf(zone)
                this.form.functional_test.zones.splice(index, 1);
                this.removeZoneFromQuestions(zone);
            }).catch(() => {
            })
        },

        removeZoneFromQuestions(zone) {
            _.each(this.form.functional_test.steps, step => {
                _.each(step.questions, question => {
                    if (!this.isText(question)) {
                        // question.zones.indexOf(zone)
                    }
                })
            })
        },

        addZone() {
            if (this.hasMaxZones) return;
            Alert.options('Select type of zone...', this.zone_options).then(response => {
                this.updateQuestionZones(response.value)
            }).catch(() => {
                if (this.data == null) {
                    this.redirectTo(this.returnUrl)
                }
            })
        },

        updateQuestionZones(zone) {
            this.form.functional_test.zones.push(zone);
            _.each(this.form.functional_test.steps, step => {
                _.each(step.questions, question => {
                    if (question.type != 'Text') {
                        question.zones.push({
                            zone: zone,
                            disabled: false,
                            display: true,
                            style: {},
                            answer: this.getDefaultValueForDinamicQuestion(question),
                        });
                    }
                })
            })
        }
    },

    computed: {

        displayTestingSection() {
            if (this.form.nlcaa_procedure.questions.usign_artificial_light_test.answer == false) return true;
            if (this.form.nlcaa_procedure.questions.method_used_for_the_test.answer != '') {
                if (this.form.nlcaa_procedure.questions.artificial_light_test_reason.answer == 'Other') {
                    return this.form.nlcaa_procedure.questions.other_reason.answer.length > 5;
                } else {
                    return this.form.nlcaa_procedure.questions.artificial_light_test_reason.answer != '';
                }
            }
            return false;
        },

        rowColspan() {
            return this.form.functional_test.zones.length;
        },

        hasMaxZones() {
            if (this.testIsReady) {
                return this.form.functional_test.zones.length >= this.max_zones;
            }
            return false;
        }
    }
}
